<template>
  <div>
    <a-result
      status="error"
      :title="$t('统一身份认证登录失败')"
      sub-title=""
    >
      <div slot="extra">
        <a-button type="primary" @click="handleBack">{{ $t('返回') }}</a-button>
      </div>
    </a-result>
  </div>
</template>
<script>

export default {
  data() {
    return {}
  },
  methods: {
    handleBack() {
      this.$router.replace({ path: '/login' })
    }
  }
}

</script>